import { Vector3 as r } from "three";
import { isVector3 as t } from "./three/index15.js";
const m = (o) => t(o) ? o : new r(...o);
export {
  m as V3toVector3
};
//# sourceMappingURL=index9.js.map
